import type { MultiSelectOption } from '@/common/MultiSelectDropdown';
import { loadOrderFilterOptions } from '@/library/OrderFilterOptionsHelper';
import { orderSettingsKeys, parseOrderSearchDefaults } from '@/library/OrderSettingsHelper';
import { getUser } from '@/library/UserSessionHelper';
import { initialQuery, type OrdersDashboardQuery } from './OrdersQuery';
import { OrdersPageType } from './OrdersPresentation';

export const loadOrderDefaults = async (page: OrdersPageType): Promise<{ query: OrdersDashboardQuery; hasMissingSelections: boolean }> => {
  const [user, options] = await Promise.all([getUser(), loadOrderFilterOptions(page, false)]);
  const defaults = parseOrderSearchDefaults(user?.orderSettings?.[orderSettingsKeys[page]]?.appUserSetting?.setting);
  let hasMissingSelections = false;
  const select = (ids: number[], available: MultiSelectOption[]) => {
    const matches = available.filter((option) => ids.includes(Number(option.value)));
    if (matches.length !== ids.length) hasMissingSelections = true;
    return matches;
  };
  const query: OrdersDashboardQuery = {
    ...initialQuery,
    orderStatus: select(defaults.orderStatuses, options.orderStatuses),
    account: select(defaults.orderAccounts, options.orderAccounts),
    tourRep: select(defaults.appUsers, options.appUsers),
  };
  if (page !== OrdersPageType.Putters) query.clubSupply = select(defaults.headTypes, options.headTypes);
  if (page === OrdersPageType.Components) {
    query.shipFrom = select(defaults.shipFromLocations, options.buildLocations);
    query.shipTo = select(defaults.shipToLocations, options.buildLocations);
  } else {
    query.buildLocation = select(defaults.buildLocations, options.buildLocations);
  }
  return { query, hasMissingSelections };
};
